
<template>
  <div v-wechat-title="Mytitle">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <template v-if="isSplitOrder">
      <van-tabs v-model="selectOrder" :background="GetColorMain()" :border="false" color="#fff" title-active-color="#fff" title-inactive-color="#fff" @change="onOrderChange">
        <van-tab v-for="(item,index) in bortherOrderId" :key="index" :title="'子订单'+(index+1)" :name="item" />
      </van-tabs>
      <div class="state" :style="'height: 3.5em;background-color: '+GetColorMain()" />
      <div class="trafficAddress">
        <div class="lines">
          <div class="line">
            <van-row>
              <van-col span="12" class="stateLine">
                {{ GetEnumText("Em_OrderState",data.state) }}
              </van-col>
              <van-col v-if="data.freightCompanyCode" span="12" class="stateLineSmall rigth">
                {{ (data.freightCompanyName?data.freightCompanyName:data.freightCompanyCode) }}
              </van-col>
              <van-col v-if="data.state === 'CREATE'" span="12" class="name rigth">
                <van-count-down v-if="autoCloseTime>0" :time="autoCloseTime" format="剩余：HH小时mm分钟" class="autoTime" />
                <span v-if="autoCloseTime<=0">订单即将关闭</span>
              </van-col>
            </van-row>
          </div>
        </div>
        <div v-if="data.lastExpressDate" class="lines" @click="onClickDistribution(data.orderId)">
          <div class="leftIcon">
            <i class="iconfont iconqianshou" />
          </div>
          <div class="line">
            <div class="xpressBody">
              {{ data.lastExpressBody }}
            </div>
            <span>{{ formatDate(data.lastExpressDate,"yyyy/MM/dd hh:mm:ss",false) }}</span>
          </div>
        </div>
        <div class="lines">
          <div class="leftIcon">
            <i class="iconfont icondizhi" />
          </div>
          <div class="line">
            <span class="name">{{ data.bookMan }} {{ data.bookContact }}</span>
            <br><span>地址：{{ data.address }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="!isSplitOrder">
      <div class="state" :style="'background-color: '+GetColorMain()">
        <div class="body">
          <van-row>
            <van-col span="12" class="stateLine">
              {{ GetEnumText("Em_OrderState",data.state) }}
            </van-col>
            <van-col v-if="data.freightCompanyCode" span="12" class="stateLineSmall rigth">
              {{ (data.freightCompanyName?data.freightCompanyName:data.freightCompanyCode) }}
            </van-col>
            <van-col v-if="data.state === 'CREATE'" span="12" class="name rigth">
              <van-count-down v-if="autoCloseTime>0" :time="autoCloseTime" format="剩余：HH小时mm分钟" class="autoTime" />
              <span v-if="autoCloseTime<=0">订单即将关闭</span>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="trafficAddress">
        <div v-if="data.lastExpressDate" class="lines" @click="onClickDistribution(data.orderId)">
          <div class="leftIcon">
            <i class="iconfont iconqianshou" />
          </div>
          <div class="line">
            <div class="xpressBody">
              {{ data.lastExpressBody }}
            </div>
            <span>{{ formatDate(data.lastExpressDate,"yyyy/MM/dd hh:mm:ss",false) }}</span>
          </div>
        </div>
        <div class="lines">
          <div class="leftIcon">
            <i class="iconfont icondizhi" />
          </div>
          <div class="line">
            <span class="name">{{ data.bookMan }} {{ data.bookContact }}</span>
            <br><span>地址：{{ data.address }}</span>
          </div>
        </div>
      </div>
    </template>

    <div class="store">
      <i class="iconfont iconshangdian" /> {{ GetSysTitle() }}
    </div>
    <div class="commoditys">
      <div v-for="(item,index) in data.commoditys" :key="index">
        <div class="rect">
          <van-image
            width="4em"
            height="4em"
            :src="showCommoditysIcon(item)"
            @click="onShowItemOrImage(item)"
          />
          <div class="body">
            <div class="title" @click="onShowItem(item.commodityId)">
              {{ item.name }}
            </div>
            <div class="specifications" @click="onShowItem(item.commodityId)">
              x<span v-if="item.refundGoodsNum===0">{{ item.num }}</span>
              <span v-if="item.refundGoodsNum!==0" :style="'color: '+GetColorMain()"><del class="itemNumDelete">&nbsp;{{ item.num }}&nbsp;</del> {{ item.num-item.refundGoodsNum }}</span>
              规格:<van-tag v-if="item.diyData" plain type="danger" :color="GetColorMain()">{{ cutString(item.diyData.title,10) }}</van-tag> {{ item.specificationMainName }}
              <template v-if="item.specificationOtherNames">
                <span v-for="sp in item.specificationOtherNames.split('/')" :key="sp">
                  {{ sp }}
                </span>
              </template>
            <!-- <span v-if="item.tripBeginTime && !item.tripEndTime"> {{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}</span>
            <span v-if="item.tripBeginTime && item.tripEndTime"> {{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}~{{ formatDate(item.tripEndTime,"yyyy/MM/dd") }}</span> -->

            </div>
            <div class="buttons">
              <van-row>
                <van-col span="14" class="money">
                  ￥{{ ShowMoney(item.price*item.num) }}
                  <van-tag v-if="item.priceRefund>0" plain type="danger" :color="GetColorMain()">退款￥{{ ShowMoney(item.priceRefund) }}</van-tag>
                </van-col>
                <van-col span="10" class="rigth">
                  <van-button v-if="data.state ==='FINISHED'" size="small" round plain type="default" @click="onCommentItem(item)">评价晒单</van-button>
                </van-col>
              <!-- <van-col span="16" class="rigth">
                <van-button size="small" round plain type="default">申请售后</van-button>
                <van-button size="small" round plain type="default">再次购买</van-button>
              </van-col> -->
              </van-row>
            </div>
          </div>
        </div>
        <div v-if="item.isNeedContacts" class="extebdedRect">
          <van-row class="line">
            出行日期：
            <span v-if="item.tripBeginTime && !item.tripEndTime">{{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}</span>
            <span v-if="item.tripBeginTime && item.tripEndTime">{{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}~{{ formatDate(item.tripEndTime,"yyyy/MM/dd") }}</span>
          </van-row>
          <van-row class="line">
            <van-col span="10">
              出 行 人 ：
            </van-col>
          </van-row>
          <template v-if="item.customerLogs && item.customerLogs.length>0">
            <van-row v-for="customerInfo in item.customerLogs" :key="customerInfo.customerLogId" class="line lineUser">
              <van-col span="24" class="userName">
                <!-- <i class="iconfont iconclosex" /> -->
                <span>{{ customerInfo.loaclName }} / {{ customerInfo.lastName }} {{ customerInfo.firstName }}</span>
                <!--<div class="info">
                   <template v-if="!customerInfo.bindUserId">
                    <i class="iconfont iconorderNeed" />未关联用户
                  </template>
                  <template v-if="!customerInfo.birthday">
                    <i class="iconfont iconorderNeed" />未填写信息
                  </template>
                  <template v-if="customerInfo.birthday && !customerInfo.zip && item.commodityType==='COURSE'">
                    <i class="iconfont iconorderNeed" />未填写扩展信息
                  </template>
                  &nbsp;
                </div>-->
              </van-col>
              <!-- <van-col span="10" class="rigth userIcon">
                <div v-if="data.state==='PAY'" class="icon" @click="onChangeCustomer(item,customerInfo)">
                  <i class="iconfont iconorderChange" /><br>
                  <span>更换</span>
                </div>
                <div v-if="data.state==='PAY'" class="icon" @click="onCustomerEdit(item,customerInfo)">
                  <i class="iconfont iconorderEdit" /><br>
                  <span>修改</span>
                </div>
                <div v-if="data.state==='PAY'" class="icon" @click="onCustomerSend(item,customerInfo)">
                  <i class="iconfont iconorderShare" /><br>
                  <span>关联</span>
                </div>
                 <div v-if="data.state==='CONFIRMED'||data.state==='SHIPPED'||data.state==='RECEIVED'||data.state==='FINISHED'" class="icon" @click="onCustomerProgress(item,customerInfo)">
                  <i class="iconfont iconorderInfo" /><br>
                  <span>详情</span>
                </div>
              </van-col> -->
            </van-row>
          </template>
        </div>
      </div>
    </div>
    <div v-if="data.supplierName" class="supplierRect">
      由<strong>{{ data.supplierName }}</strong>提供发货&amp;售后
    </div>

    <div class="payTraffic">
      <div class="rect">
        <span>订单号：</span>{{ data.orderId }}<br>
        <span>支付方式：</span>{{ GetEnumText("Em_PayType",data.payType) }}<br>
        <template v-if="data.timePay"><span>支付时间：</span>{{ formatDate(data.timePay,"yyyy/MM/dd hh:mm:ss",true) }}<br></template>
      </div>
      <div class="rect">
        <template v-if="data.freightCompanyCode"><span>配送方式：</span>{{ (data.freightCompanyName?data.freightCompanyName:data.freightCompanyCode) }}<br></template>
        <template v-if="data.freightCode"><span>运单号码：</span>{{ data.freightCode }}<br></template>
        <span>运费：</span>{{ GetEnumText("Em_FreightType",data.freightType) }}<br>
      </div>
    </div>

    <div class="addressInfo">
      <div class="leftIcon">
        <i class="iconfont icondizhi" />
      </div>
      <div class="line">
        <span class="name">{{ data.bookMan }} {{ data.bookContact }}</span>
        <br><span>地址：{{ data.address }}</span>
      </div>
    </div>
    <div v-if="data && data.secondMoney" class="priceInfo">
      <van-row>
        <van-col span="16">商品金额</van-col>
        <van-col span="8" class="rigth">￥{{ ShowMoney(data.commodityPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.couponPrice != 0">
        <van-col span="16">优惠券</van-col>
        <van-col span="8" class="rigth">- ￥{{ ShowMoney(data.couponPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.freightPrice != 0">
        <van-col span="16">运费</van-col>
        <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.freightPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.reductionPrice != 0">
        <van-col span="16">调价</van-col>
        <van-col v-if="data.reductionPrice>=0" span="8" class="rigth">
          + ￥{{ ShowMoney(data.reductionPrice) }}
        </van-col>
        <van-col v-if="data.reductionPrice<0" span="8" class="rigth">
          - ￥{{ ShowMoney(-data.reductionPrice) }}
        </van-col>
      </van-row>
      <van-row v-if="data.commoditys[0].stepBuy === 'SECOND_OTHER'">
        <van-col span="16">尾款</van-col>
        <van-col span="8" class="rigth">
          {{ data.secondMoney.currency }} {{ ShowMoney(data.commoditys[0].stepAfterPrice*data.commoditys[0].num) }}
        </van-col>

      </van-row>
      <van-row v-if="data.commoditys[0].stepBuy === 'SECOND_OTHER' && data.commoditys[0].stepPrice!==data.commoditys[0].stepAfterPrice">
        <van-col span="16">尾款调价</van-col>
        <van-col v-if="data.commoditys[0].stepPrice-data.commoditys[0].stepAfterPrice>=0" span="8" class="rigth">
          + {{ data.secondMoney.currency }} {{ ShowMoney((data.commoditys[0].stepPrice-data.commoditys[0].stepAfterPrice)*data.commoditys[0].num) }}
        </van-col>
        <van-col v-if="data.commoditys[0].stepPrice-data.commoditys[0].stepAfterPrice<0" span="8" class="rigth">
          - {{ data.secondMoney.currency }} {{ ShowMoney((data.commoditys[0].stepAfterPrice-data.commoditys[0].stepPrice)*data.commoditys[0].num) }}
        </van-col>
      </van-row>
      <van-row v-if="data.agentPrice != 0">
        <van-col span="16">佣金直返</van-col>
        <van-col span="8" class="rigth">- ￥{{ ShowMoney(data.agentPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.scorePrice != 0">
        <van-col span="16">积分抵扣</van-col>
        <van-col span="8" class="rigth">- ￥{{ ShowMoney(data.scorePrice) }}</van-col>
      </van-row>
      <van-row v-if="data.firstMoney.payPrice + data.secondMoney.payPrice != 0">
        <van-col span="16">支付手续费</van-col>
        <van-col span="8" class="rigth">+ ￥{{ ShowMoney(data.firstMoney.payPrice + data.secondMoney.payPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.commoditys[0].stepBuy === 'SECOND_CNY'">
        <van-col span="16">总计</van-col>
        <van-col span="8" class="rigth">￥{{ ShowMoney(data.firstMoney.needPayMoney + data.firstMoney.payPrice + data.secondMoney.needPayMoney + data.secondMoney.payPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.commoditys[0].stepBuy === 'SECOND_OTHER'">
        <van-col span="8">总计</van-col>
        <van-col span="16" class="rigth">￥{{ ShowMoney(data.firstMoney.needPayMoney + data.firstMoney.payPrice) }} + {{ data.secondMoney.currency }} {{ ShowMoney(data.secondMoney.needPayMoney) }}</van-col>
      </van-row>
      <div class="stepPayRect">
        <div class="stepPayIconRect">
          <div v-if="paystate>=1" class="stepPayIcon1" :style="'background-color: '+GetColorMain()" />
          <div v-if="paystate<1" class="stepPayIcon1" />
          <div v-if="paystate>=2" class="stepPayIcon2" :style="'background-color: '+GetColorMain()" />
          <div v-if="paystate<2" class="stepPayIcon2" />
          <div class="stepPayLine" />
        </div>
        <div class="stepPayInfoRect">
          <van-row>
            <van-col span="19" class="stepPayRect"><!-- :style="'color: '+GetColorMain()" -->
              <span :style="paystate === 0?'color: '+GetColorMain():''">
                定金：￥{{ ShowMoney(data.firstMoney.needPayMoney + data.firstMoney.payPrice) }}
                <template v-if="data.firstMoney.payPrice != 0"> (已含支付手续费{{ ShowMoney(data.firstMoney.payPrice) }}元)</template>
              </span>
              <br>
              <span v-if="data.commoditys[0].stepBuy === 'SECOND_CNY'" :style="paystate === 1?'color: '+GetColorMain():''">
                尾款：￥{{ ShowMoney(data.secondMoney.needPayMoney+data.secondMoney.payPrice) }}
                <template v-if="data.secondMoney.payPrice != 0"> (已含支付手续费{{ ShowMoney(data.secondMoney.payPrice) }}元)</template>
              </span>
              <span v-if="data.commoditys[0].stepBuy === 'SECOND_OTHER'" :style="paystate === 1?'color: '+GetColorMain():''">
                尾款： {{ data.secondMoney.currency }} {{ ShowMoney(data.secondMoney.needPayMoney) }}
                <span>(约合:￥{{ ShowMoney(data.secondMoney.needPayMoneyCNY) }}</span>
                <span v-if="data.secondMoney.payPrice">+{{ ShowMoney(data.secondMoney.payPrice) }}</span>)
              </span>
            </van-col>
            <van-col span="5" class="stepPayRect rigth payState">
              &nbsp;<span v-if="paystate===0">待付款</span><span v-if="paystate===1 || paystate===2">已支付</span><br>
              &nbsp;<span v-if="paystate===1">待付款</span><span v-if="paystate===2">已支付</span>
            </van-col>
          </van-row>
        </div>
      </div>
      <div v-if="paystate!==2 && data.secondMoney.startPayTime && afterDateNow(data.secondMoney.startPayTime,true)" class="rigth payTimeAbout">尾款支付时间:{{ formatDate(data.secondMoney.startPayTime,"yyyy/MM/dd hh:mm",true) }}</div>
      <div v-if="paystate!==2 && data.secondMoney.startPayTime && data.secondMoney.lastPayTime && !afterDateNow(data.secondMoney.startPayTime,true) && afterDateNow(data.secondMoney.lastPayTime,true)" class="rigth payTimeAbout">
        截止支付时间:{{ formatDate(data.secondMoney.lastPayTime,"yyyy/MM/dd hh:mm",true) }}
      </div>
      <div v-if="paystate!==2 && data.secondMoney.lastPayTime && !afterDateNow(data.secondMoney.lastPayTime, true)" class="rigth payTimeAbout" :style="'color: '+GetColorMain()">已超尾款支付期限,请尽快支付!</div>
    </div>

    <div v-if="data && data.firstMoney && !data.secondMoney" class="priceInfo">
      <van-row>
        <van-col span="12">
          商品总额
        </van-col>
        <van-col span="12" class="rigth">
          ￥{{ data.commodityPrice.toFixed(2) }}
        </van-col>
      </van-row>
      <van-row v-if="data.freightPrice !== 0">
        <van-col span="12">
          运费
        </van-col>
        <van-col span="12" class="rigth">
          + ￥{{ data.freightPrice.toFixed(2) }}
        </van-col>
      </van-row>
      <van-row v-if="data.reductionPrice !== 0">
        <van-col span="12">
          调价
        </van-col>
        <van-col v-if="data.reductionPrice>=0" span="12" class="rigth">
          + ￥{{ data.reductionPrice.toFixed(2) }}
        </van-col>
        <van-col v-if="data.reductionPrice<0" span="12" class="rigth">
          - ￥{{ -data.reductionPrice.toFixed(2) }}
        </van-col>
      </van-row>
      <van-row v-if="data.couponPrice !== 0">
        <van-col span="12">
          优惠券
        </van-col>
        <van-col span="12" class="rigth">
          - ￥{{ data.couponPrice.toFixed(2) }}
        </van-col>
      </van-row>
      <van-row v-if="data.agentPrice != 0">
        <van-col span="16">佣金直返</van-col>
        <van-col span="8" class="rigth">- ￥{{ ShowMoney(data.agentPrice) }}</van-col>
      </van-row>
      <van-row v-if="data.scorePrice !== 0">
        <van-col span="12">
          积分抵扣
        </van-col>
        <van-col span="12" class="rigth">
          - ￥{{ data.scorePrice.toFixed(2) }}
        </van-col>
      </van-row>
      <van-row v-if="data.firstMoney.payPrice !== 0">
        <van-col span="12">
          支付手续费
        </van-col>
        <van-col span="12" class="rigth">
          + ￥{{ data.firstMoney.payPrice.toFixed(2) }}
        </van-col>
      </van-row>
    </div>
    <div v-if="data.firstMoney && !data.secondMoney" class="priceTotal">
      {{ data.firstMoney.payState==='WAIT'?"应付款：":"实付款：" }}
      <span :style="'color: '+GetColorMain()">￥{{ (data.firstMoney.needPayMoney+data.firstMoney.payPrice).toFixed(2) }}</span>
    </div>
    <div class="emptyRect" />
    <div class="totalBar">
      <van-row>
        <van-col span="6">
          <span v-if="data.state==='CANCEL'" @click="onDelete(data.orderId)">
            删除订单
          </span>
        </van-col>
        <van-col span="18" class="rigth">
          <template v-if="data.state ==='CANCEL' || data.state === 'FINISHED' || data.state === 'REFUND'">
            <van-button size="small" round plain type="default" @click="onBuyAgain(data)">再次购买</van-button>
          </template>
          <template v-if="data.state ==='FINISHED'">
            <van-button size="small" round plain type="default" @click="onComment(data)">评价晒单</van-button>
          </template>
          <template v-if="data.state ==='PAYWAIT' || data.state ==='PAYWAIT_SECOND'">
            <van-button size="small" round plain type="default" @click="onPay(data)">支付信息</van-button>
          </template>
          <template v-if="data.state ==='CREATE'">
            <van-button size="small" round plain type="default" @click="onCancel(data)">取消订单</van-button>
            <van-button size="small" round plain type="default" @click="onPay(data)">立即支付</van-button>
          </template>
          <template v-if="data.state ==='CREATE_SECOND' && !afterDateNow(data.secondMoney.startPayTime,true)">
            <van-button size="small" round plain hairline type="danger" :color="GetColorMain()" @click="onPay(data)">支付尾款</van-button>
          </template>
          <template v-if="data.state ==='SHIPPED' || data.state === 'RECEIVED'">
            <van-button size="small" round plain type="default" @click="onReceiving(data)">确认收货</van-button>
          </template>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Button, Image, Dialog, Tag, Tab, Tabs, CountDown, Toast } from 'vant'
import { cutString, MyNotify, getUrlKey, afterDateNow, ShowMoney, GetEnumText, formatDate, UrlBase64 } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { ImagePreview } from 'vant'
import { GetSelfUrl } from '@/utils/request'
import { getToken } from '@/utils/auth'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [ImagePreview.name]: ImagePreview,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    TopBar
  },
  data() {
    return {
      Mytitle: '',
      system: undefined,
      title: '我的订单',
      backurl: '/store/orderList',
      id: undefined,
      paystate: 0,
      isSplitOrder: false,
      selectOrder: undefined,
      bortherOrderId: [],
      autoCloseTime: undefined,
      buttonLoading: false,
      data: {
        state: undefined,
        commoditys: [],
        commodityPrice: 0,
        freightPrice: 0,
        reductionPrice: 0,
        couponPrice: 0,
        scorePrice: 0,
        payPrice: 0,
        totalPrice: 0
      },
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      shareMessage: '',
      shareToast: undefined,
      showContactsSelectNum: 0,
      contactsSelectList: [],
      contactsDisableList: [],
      selectOrderCommodityId: undefined
    }
  },

  created() {
    this.system = getUrlKey('system')
    this.Mytitle = GetSysTitle()
    this.id = this.$route.params.id
    this.init(this.id, () => {
      this.init(this.selectOrder)
    })
  },
  methods: {
    MyNotify,
    GetSelfUrl,
    cutString,
    afterDateNow,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onClickDistribution(id) {
      this.$router.push('/store/orderDistribution/' + id)
    },
    onOrderChange() {
      console.log('订单切换成:' + this.selectOrder)
      this.init(this.selectOrder)
    },
    init(id, callback) {
      request({
        url: '/Store/getOrder',
        method: 'post',
        params: { orderId: id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.id = response.data.orderId
        if (response.data.state === 'CREATE') {
          var time = formatDate(response.data.timeAutoClose, 'yyyy/MM/dd hh:mm:ss', true)
          console.log(time)
          this.autoCloseTime = new Date(time).getTime() - new Date().getTime()
          console.log(this.autoCloseTime)
        }
        if (response.data.bortherOrderId && response.data.bortherOrderId.length >= 2) {
          this.bortherOrderId = response.data.bortherOrderId
          this.isSplitOrder = true
          if (!this.selectOrder) {
            if (response.data.isSplit) {
              this.selectOrder = response.data.bortherOrderId[0]
            } else {
              this.selectOrder = id
            }
          }
        } else {
          this.bortherOrderId = []
          this.isSplitOrder = false
        }
        console.log('isSplitOrder0', this.isSplitOrder)
        if (response.data.isSplit) {
          if (callback) {
            callback()
          }
          return
        }
        this.data = response.data
        if (this.data.state === 'CREATE' || this.data.state === 'CANCEL') {
          this.paystate = 0
        } else if (this.data.state === 'PAY' || this.data.state === 'PAYWAIT' || this.data.state === 'PAY_FIRST' || this.data.state === 'CREATE_SECOND') {
          this.paystate = 1
        } else {
          this.paystate = 2
          if (this.data.state === 'REFUND' && this.data.secondMoney && this.data.secondMoney.payState !== 'WAIT') {
            this.paystate = 1
          }
        }
        console.log('paystate', this.paystate)
        this.isAnyNeedContacts = false
        this.data.commoditys.forEach(item => {
          item.isNeedContacts = item.commodityType === 'SCHEDULING' || item.commodityType === 'COURSE'
          if (item.isNeedContacts) {
            this.isAnyNeedContacts = true
          }

          if (item.diyData) {
            item.diyData = JSON.parse(item.diyData)
          }
        })
      })
    },
    onDelete(orderId) {
      Dialog.confirm({
        title: '删除订单',
        message: '确认删除此订单?'
      }).then(() => {
        if (this.buttonLoading) {
          return
        }
        this.buttonLoading = true
        request({
          url: '/Store/OrderDelete',
          method: 'post',
          params: { orderId: orderId }
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push('/Store/orderList')
        })
      })
    },
    onCancel(item) {
      Dialog.confirm({
        title: '取消订单',
        message: '确认取消此订单?'
      }).then(() => {
        if (this.buttonLoading) {
          return
        }
        this.buttonLoading = true
        request({
          url: '/Store/orderCancel',
          method: 'post',
          params: { orderId: item.orderId }
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          this.init(this.id)
        })
      })
    },
    onBuyAgain(item) {
      // var data = ''
      // item.commoditys.map((item) => {
      //   data += item.commodityId + '|' + item.num + '|' + item.specificationMain + '|' + (item.specificationOther ? item.specificationOther : '') + '|'
      // })
      // this.$router.push('/store/ordercreate?data=' + data)
      // this.$router.push('/store/item/' + item.commodityId)
    },
    onReceiving(item) {
      Dialog.confirm({
        title: '确认收货',
        message: '确认您已经收到商品?'
      }).then(() => {
        if (this.buttonLoading) {
          return
        }
        this.buttonLoading = true
        request({
          url: '/Store/OrderReceiving',
          method: 'post',
          params: { orderId: item.orderId }
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          this.$router.push('/store/orderReceiving/' + item.orderId)
        })
      })
    },
    onComment(item) {
      this.$router.push('/store/orderCommentList/' + item.orderId)
    },
    onCommentItem(item) {
      this.$router.push('/store/orderComment/' + this.id + '?commodityId=' + item.commodityId + '&specificationMain=' + item.specificationMain + '&specificationOther=' + item.specificationOther)
    },
    onPay(item) {
      this.$router.push('/store/pay/' + item.orderId)
    },
    onShowItem(ItemId) {
      this.$router.push('/store/item/' + ItemId)
    },
    showCommoditysIcon(data) {
      if (data.diyType === 'NONE' || !data.diyIcon) {
        return data.icon
      }
      var url = data.diyIcon +
        '?specificationId=' + data.specificationMain +
        '&nickName=' + encodeURIComponent(data.diyData.nickName) +
        '&certificateTeam=' + encodeURIComponent(data.diyData.certificateTeam) +
        '&certificateId=' + encodeURIComponent(data.diyData.certificateId) +
        '&extendedData=' + (data.diyData.extendedData ? encodeURIComponent(data.diyData.extendedData) : '') +
        '&orderId=' + this.data.orderId +
        '&token=' + UrlBase64(getToken())
      return url
    },
    onShowItemOrImage(data) {
      console.log('onShowItemOrImage', data)
      if (data.diyType === 'NONE' || !data.diyIcon) {
        this.onShowItem(data.commodityId)
      } else {
        if (data.diyType === 'CIRCULAR_SEAL') {
          ImagePreview([
            this.showCommoditysIcon(data)
          ])
        } else if (data.diyType === 'CARD') {
          var url = this.showCommoditysIcon(data)
          ImagePreview([
            url + '&id=0',
            url + '&id=1'
          ])
        }
      }
    }
  }
}
</script>
<style scoped>
.state{
    height: 6em;
    position: relative;
    z-index: 1;
}
.state .body
{

    position: absolute;
    top: 1em;
    left: 1em;
    right: 1em;
    color: #fff;
}
.state .body .title{
    font-weight: 700;
}
.state .body .name{
    font-size: 0.9em;
}
.trafficAddress
{
    position: relative;
    background-color: #fff;
    margin: -2.5em 1em 0 1em;
    z-index: 10;
    border-radius: 0.5em;
    padding: 0.3em 0.5em;
    box-shadow: 0px 3px 5px #eaeaea;
}
.trafficAddress .lines{
    position: relative;
    padding: 0.3em 0;
}
.trafficAddress .line{
    margin: 0  1.2em 0 1.2em;
}
.trafficAddress .line span{
    font-size: 0.8em;
}
.trafficAddress .xpressBody{
  font-size: 0.9em;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.trafficAddress .line .state{
  font-size: 1em;
  font-weight: 700;
}
.trafficAddress .line .stateLine{
    font-size: 1em;
    font-weight: 700;
}
.trafficAddress .line .stateLineSmall{
    font-size: 0.9em;
}
.leftIcon{
    position: absolute;
    left: 0em;
    top:0.8em;
}

.store{
    margin-top: 0.7em;
    padding: 0.5em;
    background-color: #fff;
    line-height: 2em;
    border-bottom: 1px solid #fafafa;
}
.supplierRect{
  padding: 0 0.5em;
  background-color: #fff;
  font-size: 0.8em;
  color: #999;
  line-height: 2em;
}
.commoditys{
    padding: 0 0.5em;
    background-color: #fff;
}
.commoditys .rect{
    position: relative;
    padding: 0.5em 0;
    border-bottom: 1px solid #fafafa;
}
.commoditys .rect .body{
    position: absolute;
    left: 4.8em;
    top:0.5em;
    right: 0.5em;
}
.commoditys .rect .body .title{
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.commoditys .rect .body .specifications{
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  font-size: 0.8em;
  line-height: 1.8em;
}
.commoditys .rect .body .buttons{

}
button{
    margin-right: 0.5em;
    padding:0 1em;
}
.commoditys .rect .body .buttons .money{
    font-weight: 700;
    padding: 0.2em 0;
}

.payTraffic{
    margin-top: 1em;
    background-color: #fff;
    padding: 0 0.5em;
}
.payTraffic .rect{
    border-bottom: 1px solid #fafafa;
    padding: 0.5em 0 ;
    line-height: 1.8em;
}
.payTraffic .rect span{
    font-weight: 700;
}
.addressInfo{
    margin-top: 1em;
    position: relative;
    background-color: #fff;
    padding: 1em 0.5em;
}
.addressInfo .line{
    margin-left:  1.5em;
}
.addressInfo  .leftIcon{
    position: absolute;
    left: 0.5em;
    top:1em;
}
.addressInfo .line .name{
    font-weight: 700;
}
.priceInfo{
     margin-top: 1em;
    position: relative;
    background-color: #fff;
    padding: 1em 0.5em;
    line-height: 1.8em;
}
.priceTotal{
    position: relative;
    background-color: #fff;
    border-top: 1px solid #fafafa;
    line-height: 3em;
    text-align: right;
    font-weight: 700;
}
.priceTotal span{
    font-size: 1.1em;
    padding: 0 0.5em;
}
.emptyRect{
    height: 4em;
}
.totalBar{
    border-top: 1px solid #fafafa;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 3em;
    right: 0;
    background-color: #fff;
    line-height: 3em;
    padding: 0 0.5em;
}
.stepPayRect{
  position: relative;
  height: 3.6em;
}
.stepPayRect .stepPayIconRect
{
  position: absolute;
  left: 0;
  top: 0;
}
.stepPayRect .stepPayInfoRect{
  position: absolute;
  left: 1.2em;
  top: 0;
  right: 0;
  height: 3.6em;
  line-height: 1.8em;
}
.stepPayRect .stepPayInfoRect span{
  font-size: 0.9em;
}
.stepPayRect .stepPayInfoRect .payState
{
  color: #999;
}
.stepPayRect .stepPayIconRect .stepPayLine{
  position: absolute;
  width: 1px;
  height: 0.8em;
  background-color: #dadada;
  left: 0.4em;
  top:1.4em;
}
.stepPayRect .stepPayIconRect .stepPayIcon1{
  position: absolute;
  width: 0.8em;
  height: 0.8em;
  background-color: #dadada;
  border-radius: 1em;
  left: 0;
  top:0.5em;
}
.stepPayRect .stepPayIconRect .stepPayIcon2{
  position: absolute;
  width: 0.8em;
  height: 0.8em;
  background-color: #dadada;
  border-radius: 1em;
  left: 0;
  top:2.3em;
}
.payTimeAbout{
  color: #999;
  font-size: 0.9em;
  line-height: 1em;
}
.itemNumDelete{
  color: #999;
}
.autoTime{
  color: #fff;
}

.extebdedRect{
  font-size: 0.9em;
  line-height: 30px;
   border-bottom: 1px solid #cacaca;
   margin: 0 0 0 0;
}

.extebdedRect .line{
  /*padding:0.5em 0;
   //border-top: 1px solid #eaeaea; */

}
.extebdedRect .lineUser{
border-bottom: 1px solid #eaeaea;
}
.extebdedRect .lineUser:last-child{
  border-bottom:none;
}
.extebdedRect .line .userName span{
  font-weight: 700;
  font-size: 1.5em;
  line-height: 1.8em;
}
.extebdedRect .line .userName .info
{
  font-size: 1em;
  font-weight: 400;

}
.extebdedRect .line .userName .info i{
  margin-right: 0.3em;
  font-size: 1.2em;
  font-weight: 700;
}
.extebdedRect .line .userIcon{
  display:flex;
  display:-webkit-flex;
  justify-content:flex-end;
   line-height: 1.5em;
   padding-top: 0.5em;
}
.extebdedRect .line .userIcon .icon{
  text-align: center;
  margin-left: 0.7em;
  margin-top: 0.3em;
  font-size: 1.3em;
}
.extebdedRect .line .userIcon .icon span{
  color:#999;
  font-size: 0.5em;
}
.extebdedRect .line .userIcon .icon i{
  font-size: 1em;
  font-weight: 700;
}
</style>
